export enum CurrencyToSymbolEnum {
  CHF = '₣',
  USD = '$',
  EUR = '€',
}

export default {
  CurrencyToSymbolEnum,
};
